<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Filtros">
        <NxInput
          v-model="form.email"
          name="email"
          type="text"
          label="E-mail:"
          placeholder="Digite o e-mail"
          @update:value="handleInputUpdate('email', $event)"
        />
        <NxInput
          v-model="form.data"
          name="data"
          type="date"
          label="Data do bloqueio:"
          placeholder="Escolha a data"
          @update:value="handleInputUpdate('data', $event, false)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'

export default {
  name: 'SidebarBlockListEmail',
  components: { SidebarSearch, SearchCollapse },
  data () {
    return {
      form: {
        email: null,
        data: null
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.form.email = null
      this.form.data = null
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        if (fieldName === 'email') {
          this.form[fieldName] = clean
            ? inputedValue.replace(/[^a-zA-Z0-9@._-]/g, '')
            : inputedValue
        } else {
          this.form[fieldName] = inputedValue
        }
      } else {
        this.form[fieldName] = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/blocklist/BlockList/components/search/SidebarBlockListEmail.vue